/* eslint-disable sort-keys */
export default {
  primaryColor: '#29AFA0',
  quaternaryColor: '#E20714',
  quinaryColor: '#E9F7F5',
  secondaryColor: '#008798',
  senaryColor: '#158B80',
  tertiaryColor: '#E94190',
}
